import { render } from "./ProgrammaLavoro.vue?vue&type=template&id=5ce52641&scoped=true&ts=true"
import script from "./ProgrammaLavoro.vue?vue&type=script&lang=ts"
export * from "./ProgrammaLavoro.vue?vue&type=script&lang=ts"

import "./ProgrammaLavoro.vue?vue&type=style&index=0&id=5ce52641&scoped=true&lang=css"

import exportComponent from "/Users/andrea/Sites/app_v2/app_entasys/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5ce52641"]])

export default __exports__